import * as React from 'react';
import * as styled from './styled';
import {Viewer} from 'components/Viewer';
import {ResultGroup} from './components/ResultGroup';
import {BlocksGroup} from './components/BlocksGroup';
import BuilderFooter from 'components/BuilderFooter';
import Button, {ButtonVariant} from 'components/Button';
import {TaskViewerProps} from './types';

/**
 * The component view task.
 * @param {TaskViewerProps} props
 * @return {React.ReactElement<TaskViewerProps>}
 * @constructor
 */
export default function TaskViewer(
  {
    task,
  }: TaskViewerProps,
): React.ReactElement<TaskViewerProps> {
  /**
   * Render header.
   * @return {JSX.Element}
   */
  function renderHeader(): JSX.Element {
    return (
      <Viewer.Header
        preview={task.preview}
        tags={task.tags}
        title={task.title}
        description={task.description}
        authorId={task.authorId}
      />
    );
  }

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render result group.
     * @return {JSX.Element}
     */
    function renderResultGroup(): JSX.Element {
      return (
        <ResultGroup
          settings={task.settings}
          progress={task.progress}
        />
      );
    }

    /**
     * Render blocks group.
     * @return {JSX.Element}
     */
    function renderBlocksGroup(): JSX.Element {
      return (
        <styled.Blocks>
          <styled.DueTime>
            {'Сдать задания до 24 августа 2021'}
          </styled.DueTime>
          <styled.Label>
            {'Если вы не сдадите все задания в срок, то они будут оценены в 0 баллов.'}
          </styled.Label>
          <BlocksGroup
            content={task.content}
          />
        </styled.Blocks>
      );
    }

    return (
      <styled.Wrapper>
        {renderResultGroup()}
        {renderBlocksGroup()}
      </styled.Wrapper>
    );
  }

  /**
   * Render footer.
   * @return {JSX.Element}
   */
  function renderFooter(): JSX.Element {
    return (
      <BuilderFooter>
        <Button type="button" variant={ButtonVariant.Outline}>
          Вернуться к содержанию
        </Button>
      </BuilderFooter>
    );
  }

  return (
    <Viewer>
      {{
        header: renderHeader(),
        content: renderContent(),
        footer: renderFooter(),
      }}
    </Viewer>
  );
}
